import { jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { isDefined, EventService } from "@perxis-auto/shared/lib";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import { APP_EVENT_BUTTON_IDS, APP_EVENTS } from "../../../shared/config/events.js";
import "../../../shared/context/constructor.js";
import { useThisContext, useLoadingContext } from "../../../shared/context/this.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "@perxis-auto/ui-kit";
import { QueryParamsEnum } from "../../../shared/types/router.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const {
    id = APP_EVENT_BUTTON_IDS.BOOKING_FROM_CAR_PAGE,
    iconName,
    iconSize,
    children,
    onClick,
    scrollTo,
    type = "primary",
    ...props
  } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const vehicleItem = useThisContext();
  const isLoading = useLoadingContext();
  const { t } = useTranslation(APP.name);
  const [_, setSearchParams] = useSearchParams();
  const eventPayload = useMemo(
    () => ({
      id,
      ...isDefined(vehicleItem) && { data: vehicleItem }
    }),
    [id, vehicleItem]
  );
  const handleClick = useCallback(
    (e) => {
      if (scrollTo) {
        setSearchParams((prev) => {
          prev.set(QueryParamsEnum.ScrollTo, scrollTo);
          return prev;
        });
      }
      EventService.getInstance().sendEvent(APP_EVENTS.ButtonClicked, eventPayload);
      return onClick == null ? void 0 : onClick(e);
    },
    [scrollTo, eventPayload, onClick, setSearchParams]
  );
  const resolvedIcon = useMemo(() => {
    if (typeof iconName !== "string") {
      return null;
    }
    return /* @__PURE__ */ jsx(Icon, { name: iconName, size: iconSize, sticker: "card-booking-button-icon" });
  }, [iconName, iconSize]);
  return {
    ...props,
    type,
    icon: resolvedIcon,
    children: children ?? t("widgets.cardBookingButton.children"),
    onClick: handleClick,
    isLoading
  };
};
export {
  useContainer
};
